// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".workspace-menu {\n  width: min(304px, calc(100vw - 24px));\n  max-height: calc(100vh - 32px);\n  overflow: auto;\n  padding: 8px;\n  border: 1px solid var(--portal-border);\n  border-radius: var(--brand-surface-radius, 18px) !important;\n  background-color: var(--portal-surface);\n  box-shadow: 0 20px 54px rgba(16, 17, 15, 0.2) !important;\n}", ""]);
// Exports
module.exports = exports;
